import { friendlyMessage } from '../../components/ui/friendlyMessage';
/**
 * Extract a user-facing message from auth API failures.
 * apiController throws normalized Error objects (error.message), not raw axios errors.
 */
export function getAuthApiErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  if (!error) return fallback;
  if (typeof error === 'string') return friendlyMessage(error, fallback);

  const responseData = error?.response?.data;
  const fromResponse =
    responseData?.message ||
    responseData?.error_msg ||
    (responseData?.error && typeof responseData.error === 'object'
      ? responseData.error.message
      : responseData?.error);

  if (fromResponse) return friendlyMessage(fromResponse, fallback);

  if (error?.message && error.message !== 'Request failed') {
    return friendlyMessage(error.message, fallback);
  }

  return fallback;
}
